var map = {
	"./equal.svg": "78d6",
	"./less.svg": "013a",
	"./less_equal.svg": "3f49",
	"./more.svg": "5c92",
	"./more_equal.svg": "0876",
	"./not_equal.svg": "b489"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b6c8";